module.exports = __webpack_public_path__ + "img/火龙果3.f2334063.png";